// let { REACT_APP_API_URL } = process.env;
import { localStore } from 'helpers';
import { connect } from 'react-redux';
import {
  apiUrl,
  apiUrlPublic,
  reportUrl,
  externalApi,
  customCDR
} from 'helpers/dotenv';
import Cookies from 'universal-cookie';
import axios from 'axios';
import store from 'store';
import consts from 'consts';
import { Alert } from '../theme';

const { LOGIN_TOKEN_KEY, LOGIN_REFRESH_TOKEN_KEY } = consts;

const cookies = new Cookies();

const domainName = process.env.REACT_APP_DOMAIN;
const isPortal = process.env.REACT_APP_IS_PORTAL === "true";
          
let REACT_APP_API_URL;
let tAPI = localStore.getItem('REACT_APP_API_URL');
if (
  tAPI &&
  typeof tAPI !== 'undefined' &&
  tAPI !== 'undefined' &&
  tAPI !== ''
) {
  REACT_APP_API_URL = tAPI;
}

let { CUSTOMER_ID } = process.env;
let tCustomerId = localStore.getItem('USER_ID');
if (
  tCustomerId &&
  typeof tCustomerId !== 'undefined' &&
  tCustomerId !== 'undefined' &&
  tCustomerId !== ''
) {
  CUSTOMER_ID = tCustomerId;
}

var instance = null;
class APIManager {
  constructor(tData) {
    if (instance) {
      return instance;
    }
    this.token = localStore.getItem('token');
    this.tenantId = ``;
    this.tURL = '';
    this.tDownloadUrl = '';
    // this.tURL = `${this.selectedOrganization.region.protocol}://${this.selectedOrganization.region.endpoint}/v1/`;
    // this.tDownloadUrl = `${this.selectedOrganization.region.protocol}://${this.selectedOrganization.region.endpoint}`;
    this.tURLPublic = apiUrlPublic;
    instance = this;
  }
  updateUrl(url, tenantId) {
    this.tURL = `${url}/v1/`;
    this.tDownloadUrl = `${url}`;
    this.tenantId = tenantId;
  }
  downloadUrl(fileName) {
    return `${this.tDownloadUrl}/${fileName}`;
  }
  removeByAttr(arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (
        arr[i] &&
        arr[i].hasOwnProperty(attr) &&
        arguments.length > 2 &&
        arr[i][attr] === value
      ) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }

  async sendPostAPI(route, data, sCb, fCb, type, extraHeaders, method) {
    let url = this.tURL;
    // var that = this;

    if (type && type === 'summaryReport') {
      url = reportUrl;
    } else if (type && type === 'customCDR') {
      url = customCDR;
    }
    console.log(localStore.getItem('token'));
    // const state = store.getState();
    // const localstorageslice = state.localstorageslice;
    // const RedixToken = localstorageslice ? localstorageslice.token : null;
    const token = route.includes("/common/api/v1/") 
      ? cookies.get("cpaas-token")
      : localStore.getItem('token');
    
    let header = {
      Authorization: `Bearer ${token}`,
      // 'X-TENANT-ID': localStore.getItem('selected-tenant'),
      'Content-Type': 'application/json'
    };
    if (extraHeaders) {
      header = { ...header, ...extraHeaders };
    }

    if (type === 'public') {
      // delete header.Authorization;
      delete header['X-TENANT-ID'];
    }

    if(route.includes('auth')) {
      delete header['Authorization'];
    }

    let cData = undefined;
    try {
      cData = JSON.stringify(data);
    } catch (e) {
      console.log(e);
    }
    let apiPath = url;
    if (type) {
      if (type == 'public' || type == 'public_auth') {
        apiPath = this.tURLPublic;
      } else if (type == 'direct') {
        apiPath = '';
      }
    }
    await fetch(`${apiPath}${route}`, {
      // fetch(`${this.tURL}${route}`, {
      method: method || 'POST',
      headers: header,
      body: cData
    })
      .then(async response => {
        console.log(`response:`, response);
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } 
        else if (response.status === 401) {

          if(route.includes('auth')) {
            let tBody = await response.json();
            fCb(response.status, tBody);
          } else {
            Alert.error("Login session expired! Please login again!");
            this.clearStorage();
            if(!isPortal) {
              window.location.href = '/sign-in';
            } else {
              window.location.href = `${process.env.REACT_APP_HOSTNAME}/sign-in`;
            }
          }
          
       
        } 
        // else if (response.status === 502) {
        //   Alert.error("Something went wrong!");
        //   // this.clearStorage();
        //   // window.location.href = '/sign-in';
        // } 
         else {
          let tBody = await response.json();
          fCb(response.status, tBody);
        }
      })
      .then(function(apiResponsData) {
        if (apiResponsData) {
          sCb(apiResponsData, data);
        }
      })
      .catch(e => {
        console.log(e);
        fCb(e);
      });
  }

  sendGetAPI(route, sCb, fCb, type = 'private') {
    // var that = this;
    console.log(`this.tURLPublic `, this.tURLPublic, type);
    const token = route.includes("/common/api/v1/") 
      ? cookies.get("cpaas-token")
      : localStore.getItem('token');
    
    try {
      fetch(
        `${type && type == 'public' ? this.tURLPublic : this.tURL}${route}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            // 'Content-Disposition':  'download.csv',
            // 'Content-Type': 'text/csv'

          }
        }
      )
        .then(async response => {
          console.log(`response.status === ${response.status}`);
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            Alert.error("Login session expired! Please login again!");
            this.clearStorage();
            if(!isPortal) {
              window.location.href = '/sign-in';
            } else {
              window.location.href = `${process.env.REACT_APP_HOSTNAME}/sign-in`;
            }
          } else if (response.status === 502) {
            Alert.error("Something went wrong!");
            // this.clearStorage();
            // window.location.href = '/sign-in';
          } else {
            let tBody = response.data;
            fCb(response.status, tBody);
          }
        })
        .then(function(data) {
          // console.log(data);
          sCb(data);
        })
        .catch(e => {
          console.log(e);
          fCb(e);
        });
    } catch (e) {
      console.log(e);
      fCb(e);
    }
  }

    // download csv file
    sendGetReportAPI(route, sCb, fCb, type = 'private') {
      var that = this;
      console.log(`this.tURLPublic `, this.tURLPublic, type);
      try {
        fetch(
          `${type && type == 'public' ? this.tURLPublic : this.tURL}${route}`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${localStore.getItem('token')}`,
              // 'Content-Disposition':  'download.csv',
              'Content-Type': 'text/csv'
  
            }
          }
        )
          .then(async response => {
            console.log(`response.status === ${response.status}`);
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.clearStorage();
              Alert.error("Login session expired! Please login again!");
              this.clearStorage();
              if(!isPortal) {
                window.location.href = '/sign-in';
              } else {
                window.location.href = `${process.env.REACT_APP_HOSTNAME}/sign-in`;
              }
            } else {
              let tBody = response.data;
              fCb(response.status, tBody);
            }
          })
          .then(function(data) {
            // console.log(data);
            sCb(data);
          })
          .catch(e => {
            console.log(e);
            fCb(e);
          });
      } catch (e) {
        console.log(e);
        fCb(e);
      }
    }

    
  getHeader(type, extraHeaders) {
    let header = {
      Authorization: `Bearer ${localStore.getItem('token')}`,
      'X-TENANT-ID': localStore.getItem('selected-tenant'),
      'Content-Type': type || 'application/json'
    };
    if (extraHeaders) {
      header = { ...header, ...extraHeaders };
    }
    return header;
  }
  sendPostForm(route, formData, sCb, fCb, extraHeaders, progressFn,method = 'POST', type="public") {
    // debugger;
    let headers = this.getHeader('multipart/form-data', extraHeaders);
    
    if(route.includes('/email/api/v1')) {
      headers.Authorization = `Bearer ${process.env.REACT_APP_EMAIL_TOKEN}`
    }

    axios
      ({
        method : method,
        url:`${type === "direct" ? route : this.tURLPublic+route}`, 
        data:formData, 
        headers: headers,
        onUploadProgress: progressFn
      })
      .then(function(response) {
        console.log(`response:`, response);
        if (response.status === 200) {
          return response.data;
        } else if (response.status === 401) {
          this.clearStorage();
          window.location.href = '/sign-in';
        } else {
          let tBody = response.data;
          console.log('apiResponse', response.data);
          fCb(response.status, tBody);
        }
      })
      .then(function(data) {
        if (data) {
          sCb(data);
        }
      })
      .catch(error => {
        if (error.response) {
          // Request made and server responded
          fCb(error.response.status, error.response.data);
        } else {
          // Something happened in setting up the request that triggered an Error
          fCb(0, { message: 'no response' });
        }
      });
  }
  clearStorage() {

    // remove cookies

    cookies.remove("cpass-token", { path: "/", domain: domainName });
    cookies.remove("whatsapp-token", { path: "/", domain: domainName });
    cookies.remove("sms-token", { path: "/", domain: domainName });
    cookies.remove("voice-token", { path: "/", domain: domainName });
    cookies.remove("rcs-token", { path: "/", domain: domainName });
    cookies.remove("email-token", { path: "/", domain: domainName });
    cookies.remove("userDetails", { path: "/", domain: domainName });
    cookies.remove("selected-tenant", { path: "/", domain: domainName });
    
    localStorage.removeItem(LOGIN_TOKEN_KEY);
    localStorage.removeItem(LOGIN_REFRESH_TOKEN_KEY);
    localStorage.removeItem('REACT_APP_API_SUBSCRIPTION_URL');
    localStorage.removeItem('REACT_APP_API_URL');
    localStorage.removeItem('REACT_FS_SERVER_HOST');
    localStorage.removeItem('USER_ID');
    // localStore.removeItem('selected-tenant');
    localStore.removeItem('token');
    localStore.removeItem('user');
  }
}
const mapStateToProps = state => ({
  user: state.user,
  menu: state.user.menu,
  isLogin: state.user.isLogin,
  currentUser: state.user.user,
  localstorageslice: state.localstorageslice
});

const mapDispatchToProps = {
  // toggleIsDialerOpen,
  // setUser,
  // setMenu,
  // setIsLogin,
  // setToken
};

// export default connect(mapStateToProps, mapDispatchToProps)(APIManager);
// module.exports = APIManager;

export default APIManager;



// WEBPACK FOOTER //
// ./src/modules/common/apiManager.js